var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListviewBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "List_view_-_Black",
    "data-name": "List view - Black",
    transform: "translate(-769 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2963",
    "data-name": "Rectangle 2963",
    transform: "translate(769 140)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-list-4148410",
    transform: "translate(665.182 33.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34068",
    "data-name": "Path 34068",
    d: "M107.273,245h-2.021a.272.272,0,0,0-.253.253v1.958a.289.289,0,0,0,.253.316h1.958a.289.289,0,0,0,.316-.253v-1.958A.289.289,0,0,0,107.273,245Z",
    transform: "translate(0 -129.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34069",
    "data-name": "Path 34069",
    d: "M257.377,245H245.253a.272.272,0,0,0-.253.253v1.958a.272.272,0,0,0,.253.253h12.062a.272.272,0,0,0,.253-.253v-1.958C257.63,245.126,257.5,245,257.377,245Z",
    transform: "translate(-134.948 -129.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34070",
    "data-name": "Path 34070",
    d: "M107.273,385h-2.021a.272.272,0,0,0-.253.253v1.958a.289.289,0,0,0,.253.316h1.958a.289.289,0,0,0,.316-.253v-1.958A.289.289,0,0,0,107.273,385Z",
    transform: "translate(0 -265.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34071",
    "data-name": "Path 34071",
    d: "M257.377,385H245.253a.272.272,0,0,0-.253.253v1.958a.272.272,0,0,0,.253.253h12.062a.272.272,0,0,0,.253-.253v-1.958C257.63,385.126,257.5,385,257.377,385Z",
    transform: "translate(-134.948 -265.029)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34072",
    "data-name": "Path 34072",
    d: "M107.273,105h-2.021a.272.272,0,0,0-.253.253v1.958a.289.289,0,0,0,.253.316h1.958a.289.289,0,0,0,.316-.253v-2.021A.272.272,0,0,0,107.273,105Z",
    transform: "translate(0 6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34073",
    "data-name": "Path 34073",
    d: "M257.377,105H245.253a.272.272,0,0,0-.253.253v1.958a.272.272,0,0,0,.253.253h12.062a.272.272,0,0,0,.253-.253v-1.958C257.63,105.126,257.5,105,257.377,105Z",
    transform: "translate(-134.948 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListviewBlack);
export default __webpack_public_path__ + "static/media/List view - Black.f9f01aee9ecf75bbc6f83c8601592f73.svg";
export { ForwardRef as ReactComponent };